import { render, staticRenderFns } from "./UpdateSociety.vue?vue&type=template&id=8366a81c"
import script from "./UpdateSociety.vue?vue&type=script&lang=js"
export * from "./UpdateSociety.vue?vue&type=script&lang=js"
import style0 from "./UpdateSociety.vue?vue&type=style&index=0&id=8366a81c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports